enum Services {
  Bot = 'BOT',
  CandleFetcher = 'CANDLE_FETCHER',
  WebClient = 'WEB_CLIENT',
  Data = 'DATA',
  Exchange = 'EXCHANGE',
  Control = 'CONTROL',
  Order = 'ORDER',
  ProfitCalculations = 'PROFIT_CALCULATIONS',
}

export default Services;
